// extracted by mini-css-extract-plugin
export default {"containerCart":"cart_containerCart__L5T1M","cantProducts":"cart_cantProducts__3+29B"};